import { FC } from 'react';
import { Button } from '../../../../form_components';
import { ConflictsContext } from '../context';
import {
  mapDesignConflictItems,
  setDesignConflictItemResolution
} from '../functions';
import {
  ConflictResolution,
  DesignConflictSection
} from '../types';
import {
  DesignConflictSectionContainer
} from './design-conflict-section-container';

export interface DesignConflictSectionsContainerProps {
  sections: DesignConflictSection[];
  setSections: (sections: DesignConflictSection[]) => void;
  showUnresolved: boolean;
  sourceLabel: string;
  targetLabel: string;
}

export const DesignConflictSectionsContainer: FC<(
  DesignConflictSectionsContainerProps
)> = ({
  sections,
  setSections,
  showUnresolved,
  sourceLabel,
  targetLabel
}) => {
  let remainingConflicts = 0;
  let totalConflicts = 0;
  mapDesignConflictItems(sections, (item) => {
    ++totalConflicts;
    if (item.resolution === ConflictResolution.none) {
      ++remainingConflicts;
    }
  });
  const selectAll = (resolution: ConflictResolution) => {
    setSections(mapDesignConflictItems(sections, (item) => {
      item.resolution = resolution;
      return item;
    }));
  };

  return (
    <ConflictsContext.Provider value={{
      setResolution: (key, resolution) => {
        setSections(setDesignConflictItemResolution(
          sections,
          key,
          resolution
        ));
      },
      sourceLabel,
      targetLabel
    }}>
      <div id="conflict-count-wrapper">
        <h4>
          Total Conflicts:
          <span className="conflict-count">
            {remainingConflicts} / {totalConflicts}
          </span>
        </h4>
        <div className="conflict-actions">
          <span className="conflict-actions-label">Select All:</span>
          <Button
            callback={() => selectAll(ConflictResolution.target)}
            label="Current"
          />
          <Button
            callback={() => selectAll(ConflictResolution.source)}
            label="Incoming"
          />
        </div>
      </div>
      <div
        className="changeLogPanel"
        data-show-unresolved={showUnresolved}
      >
        {sections.map((section) => {
          return (
            <DesignConflictSectionContainer
              key={section.label}
              section={section}
            />
          );
        })}
      </div>
    </ConflictsContext.Provider>
  );
};
